import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getAdharcardReqSuccess,
    getAdharcardReqError
} from './adharCardActions';
import { GET_ADHAR_CARD_KYC_REQ } from "../actionType";
import { ADHARCARD_FETCH_API } from '../../../utils/urls';
import { fetchPost } from '../../../utils/request';

const stateValue = (state: any) => state.adharCard;

function* adharcardAuth(): any {
    const stateName = yield select(stateValue);
    let body = {
        image: stateName?.adharcardImage,
        adharCard: stateName?.adharcardValue?.adharCard,
    }
    try {
         const response = yield call(fetchPost, ADHARCARD_FETCH_API, body);
        // const response :any = {
        //     // status: true,data:"data successfully",
        //     status: false,error:"No Data Found"
        // }
        if (response.error) {
            yield put(getAdharcardReqError(response));
            return false;
        }
        yield put(getAdharcardReqSuccess(response));
        return true;
    } catch (error) {
        yield put(getAdharcardReqError(error));
    }
}

export default function* legalSaga() {
    yield all([takeLatest(GET_ADHAR_CARD_KYC_REQ, adharcardAuth)])
}